const config = {
  // local: true, // 是否为本地开发
  clientId: 'client', // 必须填入响应的客户端（本地开发）
  clientSecret: 'secret',
  titlename: '医院订餐系统', // 项目页面的title名称
  favicon: 'favicon.ico', // 项目页面的icon图片名称
  theme: {
    textColor: '#fff'
  },
  // cookieServer: '', // 子域名token共享
  // server: 'https://api.sdx.console.retailsolution.cn',
  // server: 'https://pfs-testingwx.sodexo-cn.com/api', // 测试
  // server: 'https://pfs-wx.sodexo-cn.com/api', // 生产
  // server: 'https://drpfs-wx.sodexo-cn.com/api',
  server: 'https://pfs-testingwx.sodexo-cn.com/api',
  // server: 'http://47.102.109.62:8443/#/index/CN065321',
  // server: 'https://drpfs-wx.sodexo-cn.com/api',
  ossRegion: 'oss-cn-shanghai',
  ossBucket: 'sodexo-pfs-wechat',
  ossEndpoint: 'https://oss-cn-shanghai.aliyuncs.com',
  // Content-Security-Policy的content值
  content: "default-src 'self' *.wx.qq.com *.oss-cn-shanghai.aliyuncs.com 'unsafe-inline'"
}

module.exports = config
